function InitStickyBar() {
    var $page = $('.product-details-region'),
        $fixedProduct = $(".x-product-details-sticky-bar"),
        $offsetContainer = $('.' + $fixedProduct.data('offset'), $page),
        scroll, ww, mobile;

    if ($offsetContainer.offset().top === 0) {
        //set alternative offset container
        $offsetContainer = $('.region-area-five', $page);
    }

    scroll = $(window).scrollTop();
    scroll > ($offsetContainer.offset().top - 100) ? $fixedProduct.addClass("visible") : $fixedProduct.removeClass("visible");

    $(window).scroll($.throttle(100, fixedScroll));

    function fixedScroll() {
        if ($(window).outerWidth() > 767) {
            scroll = $(window).scrollTop();
            scroll > ($offsetContainer.offset().top - 100) ? $fixedProduct.addClass("visible") : $fixedProduct.removeClass("visible");
            $('html').removeClass('hide-sticky-btns');

            $('.js-anchor', $fixedProduct).each(function () {
                var target = $(this).attr('href');
                var sectionTop = $(target).offset().top - 80;
                var sectionBottom = sectionTop + $(target).outerHeight();

                if (scroll >= sectionTop && scroll < sectionBottom) {
                    $('.js-anchor', $fixedProduct).removeClass('active');
                    $(this).addClass('active');
                } else {
                    $(this).removeClass('active');
                }
            });
        } else if (isTouch() && $(window).outerWidth() < 768) {
            if ($(window).scrollTop() > ($offsetContainer.offset().top - 50)) {
                $fixedProduct.addClass('hidden');
                $('html').removeClass('hide-sticky-btns');
            } else {
                $fixedProduct.removeClass('hidden');
                $('html').addClass('hide-sticky-btns');
            }
        }

    }

    $('.js-anchor', $fixedProduct).on('click', function (e) {
        e.preventDefault();

        var target = $(this).attr('href');
        $('html, body').animate({ scrollTop: $(target).offset().top }, 200);
    });

}
